<template>
  <div :ref="uid" class="zone-escamotable" :class="jel_getClassObject(content)">
    <div :class="{ 'mb-2': content.niveauZone }" @click="toggleZoneEscamotable()">
      <div
        class="d-flex flex-row align-items-top justify-content-between"
        :class="[content.niveauZone, { 'nouveau-actif': isAfficherNouveaute }]"
      >
        <button
          :data-aide="isAide ? titre : ''"
          class="btnVide largeurZoneEscamotable px-0"
          :class="{ 'my-auto': content.niveauZone }"
        >
          <span v-if="isAfficherNouveaute" class="nouveau">
            {{ $tc('messageComponent.nouveau') }}
          </span>
          <Heading
            :id="reference"
            class="titre titre-zone-escamotable pt-0"
            :class="{ 'pb-0': content.niveauZone }"
            :contentType="content.typeTitre || 'titre'"
            v-html="titre"
          />
        </button>
        <svg-icon
          :data-aide="isAide ? titre : ''"
          icon-name="fleche-gauche"
          class="icon-fleche my-auto"
          :class="isOuvert ? 'rotation90' : 'rotation270'"
        />
      </div>
    </div>
    <div
      class="largeurZoneEscamotable marge-zone-escamotable"
      :class="{ graphik_regular: !imbrique }"
    >
      <b-collapse :visible="isOuvert">
        <div v-if="!imbrique" class="m-0 style-champ-riche mb-1" v-html="texte" />
        <div v-for="(questionRep, index) in questionsReponses" v-else :key="questionRep">
          <div class="d-flex flex-column">
            <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
            <Separateur
              v-if="index != content.typeZone.listeIdRubriqueAide.length - 1"
              class="w-100 mt-0"
            />
          </div>
        </div>
        <EditableArea
          v-if="content.contenuEditable"
          :content="content.contenuEditable"
          :parentTemplateId="metadata['mgnl:template']"
        />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

import { bus } from '@/main';
import { EditableArea } from '@/vue-editor';

import Separateur from '@/components/base/Separateur';
import Heading from '@/components/base/Heading';

export default {
  name: 'ZoneEscamotable',
  components: {
    EditableArea,
    Heading,
    Separateur,
  },
  props: { content: { type: Object, required: true }, metadata: { type: Object } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          nouveau: 'Nouveau',
        },
      },
      en: {
        messageComponent: {
          nouveau: 'New',
        },
      },
    },
  },
  data() {
    return {
      dateDebutNouveaute: null,
      dateFinNouveaute: null,
      imbrique: null,
      isAide: false,
      isOuvert: false,
      questionsReponses: null,
      reference: '',
      texte: '',
      titre: '',
    };
  },
  computed: {
    ...mapState(['aide']),
    isAfficherNouveaute() {
      const now = moment().tz('America/Montreal', true);
      const dateDebutNouveaute = moment(this.dateDebutNouveaute).tz('America/Montreal', true);
      const dateFinNouveaute = moment(this.dateFinNouveaute).tz('America/Montreal', true);

      if (this.dateDebutNouveaute && this.dateFinNouveaute) {
        return (
          dateDebutNouveaute.diff(now, 'seconds') < 0 && dateFinNouveaute.diff(now, 'seconds') > 0
        );
      }
      if (this.dateDebutNouveaute) {
        return now.diff(dateDebutNouveaute, 'days') < 30;
      }
      if (this.dateFinNouveaute) {
        return dateFinNouveaute.diff(now, 'seconds') > 0;
      }
      return false;
    },
  },
  mounted() {
    this.imbrique = this.content.imbrique;
    this.questionReponses = this.content.questionReponses;

    this.dateDebutNouveaute = this.content.dateDebutNouveaute;
    this.dateFinNouveaute = this.content.dateFinNouveaute;

    if (this.content.typeZone) {
      if (this.content.typeZone.field === 'aide') {
        this.isAide = true;
        this.getAide();
      } else if (this.content.typeZone.field === 'contenu') {
        this.reference = this.content.typeZone.idUnique || this.uid;
        this.texte = this.content.typeZone.texte;
        this.titre = this.content.typeZone.titre;
      } else if (this.content.typeZone.field === 'listeAide') {
        this.imbrique = true;
        this.questionsReponses = this.content.typeZone.listeIdRubriqueAide;
        this.reference = this.content.typeZone.idUnique || this.uid;
        this.titre = this.content.typeZone.titre;
      }
      // nécessaire pour la rétrocompatibilité
    } else {
      if (this.content.isAide) {
        this.isAide = true;
      }
      this.reference = this.content.name;
      this.texte = this.content.texte;
      this.titre = this.content.titre;
    }
    if (this.content.isOuvert == 'true') {
      this.toggleZoneEscamotable();
    }

    const self = this;
    bus.$on('ouvrirZoneEscamotable', (id) => {
      self.ouvrirZoneEscamotableAvecReference(id);
    });

    if (this.content.typeZone?.field !== 'aide') {
      this.validerOuvertureZoneEscamotable();
    }
  },
  beforeDestroy() {
    bus.$off('ouvrirZoneEscamotable');
  },
  methods: {
    async getAide() {
      this.$store.dispatch('aide/initRubriqueAide', {
        idRubriqueAide: [this.content.typeZone.idRubriqueAide],
      });

      await this.$store.dispatch('aide/toggleAide').then(() => {
        this.titre = this.aide.listeQuestionsReponses[0].question;
        this.texte = this.aide.listeQuestionsReponses[0].reponse;
        this.reference = this.aide.listeQuestionsReponses[0].name;
        this.dateDebutNouveaute = this.aide.listeQuestionsReponses[0].dateDebutNouveaute;
        this.dateFinNouveaute = this.aide.listeQuestionsReponses[0].dateFinNouveaute;
        this.validerOuvertureZoneEscamotable();
      });
    },
    validerOuvertureZoneEscamotable() {
      const hash = window.location.hash.substr(1, window.location.hash.length - 1);
      if (hash == this.reference) {
        bus.$emit('ouvrirZoneEscamotable', this.reference);
      }
    },
    ouvrirZoneEscamotableAvecReference(reference) {
      if (this.reference == reference) {
        this.isOuvert = true;
        const elementParentId = this.$refs[this.uid].parentElement.closest('.zone-escamotable');
        if (elementParentId) {
          const elementParentIdId =
            elementParentId.getElementsByClassName('titre-zone-escamotable')[0].id;
          bus.$emit('ouvrirZoneEscamotable', elementParentIdId);
          setTimeout(() => {
            this.$refs[this.uid].scrollIntoView();
          }, 500);
        }
      }
    },
    getContentZoneEscamotable(questionRep) {
      let typeTitre = 'titre';
      let niveauZone = 'niveau-2';

      // Correspond au data provenant de typeTitre.yaml
      const titresListe = [
        'tresGrandTitre,grandTitre',
        'titre',
        'sousTitre',
        'titre-h4',
        'titre-h5',
        'titre-h6',
      ];

      // Assurer le bon type de titre pour l'accessibilité
      if (this.content.typeTitre) {
        let index = titresListe.indexOf(this.content.typeTitre);
        index = titresListe.length - 1 === index ? index : index + 1;
        typeTitre = titresListe[index];
      }

      // Assurer le bon css pour le niveau de la prochaine zone escamotable
      if (this.content.niveauZone) {
        const niveau = this.content.niveauZone.split('-');
        niveauZone = `niveau-${parseInt(niveau[1], 10) + 1}`;
      }
      return {
        isOuvert: false,
        niveauZone,
        restreindreLargeur: false,
        typeTitre,
        typeZone: {
          field: 'aide',
          idRubriqueAide: questionRep,
        },
      };
    },
    toggleZoneEscamotable() {
      this.isOuvert = !this.isOuvert;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin headings {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    @content;
  }
}
.largeurZoneEscamotable {
  width: 95%;
}
.marge-zone-escamotable {
  margin: auto;
}
#modal-aide .marge-zone-escamotable {
  margin: 0;
}
button:focus {
  outline: none;
}
.titre-zone-escamotable {
  font-size: 18px;
  line-height: 1.5rem;
  text-align: left;
}
.mt-0-6 {
  margin-top: 0.3rem;
}
.zone-escamotable {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}

.nouveau {
  background-color: #ff355a;
  border-radius: 8px;
  color: #ffffff;
  font-family: graphik_semibold;
  font-size: 12px;
  padding: 4px 12px;
}

svg {
  fill: $couleur-primaire;
}

.niveau-1,
.niveau-2,
.niveau-4,
.niveau-5 {
  svg {
    fill: $couleur-primaire;
  }
}

.niveau-1 {
  padding: 10px 12px;
  @include headings {
    color: $couleur-primaire !important;
    font-family: graphik_bold;
    font-size: 24px;
  }
}

.niveau-2 {
  background-color: $couleur-primaire;
  border-radius: 35px;
  padding: 12px 20px;

  &.nouveau-actif {
    border-radius: 35px;
  }
  @include headings {
    color: white !important;
    font-family: graphik_semibold;
    font-size: 22px;
  }
  svg {
    fill: $couleur-blanc;
  }
}

.niveau-3 {
  background-color: #84b9ea;
  border-radius: 25px;
  padding: 10px 18px;

  &.nouveau-actif {
    border-radius: 35px;
  }
  @include headings {
    color: $couleur-primaire !important;
    font-family: graphik_semibold;
    font-size: 18px;
  }
}

.niveau-4 {
  @include headings {
    color: #192872 !important;
    font-family: graphik_semibold;
    font-size: 18px;
  }
}

.niveau-5 {
  @include headings {
    color: #060b32 !important;
    font-family: graphik_semibold;
    font-size: 18px;
  }
}
</style>
